import { Button } from '@lib/components'
import { type FC, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Step } from '~/components/CheckoutProgress'
import { PageForCheckoutFlow } from '~/components/Page'
import arrowRight from '~/assets/icons/arrow-right-white.svg'
import { useCheckoutPlan, MTDtracking } from '@shamaazi/mytennights'
import { useAuth } from '@lib/hooks'
import { MytennightsTestId } from '@lib/testing'
import { QurbaniWidget } from '~/components/QurbaniWidget'
interface QurbaniProps {
  nextPage: string
}

// Main Qurbani component
export const Qurbani: FC<QurbaniProps> = ({ nextPage }) => {
  const navigate = useNavigate()
  const { user } = useAuth()
  const { plan, setPlan } = useCheckoutPlan()

  const setCauses = (causes: Record<string, number>): void => {
    setPlan({
      ...plan,
      causes
    })
  }

  const handleContinue = useCallback((): void => {
    MTDtracking.confirmQurbani(user?.email, plan)
    navigate(nextPage)
  }, [navigate, nextPage, plan, user?.email])

  return (
    <PageForCheckoutFlow progressBarStep={Step.Qurbani} withQurbani={true} skinny={true}>
      <div className="w-full flex flex-col items-center gap-y-4">
        <h1 className="text-mtd-h2 font-bold text-mtd-secondary-5 hidden md:block">Extra</h1>
        <div className="flex flex-col gap-y-8">
        <QurbaniWidget charityCauses={plan.charity.causes} setCauses={setCauses} checkoutCauses={plan.causes} currency={plan.charity.currency}/>
        </div>
        <Button
          variant="mtd-primary"
          className="w-full text-mtd-h2 font-bold flex flex-row items-center justify-center gap-x-3"
          onClick={handleContinue}
          data-test-id={MytennightsTestId.continueButton}
        >
          CONTINUE
          <img src={arrowRight} alt="arrow right" className="w-6 h-6" />
        </Button>
      </div>
    </PageForCheckoutFlow>
  )
}
